// Репліки кавенятка в хмарці на головному екрані — тексти власника
// (27.09.2026). Кожна ситуація — масив варіантів: хмарка показує випадковий,
// а повтор того, що репліку викликав, — інший (Plant.jsx, Bubble). Тексти —
// лише тут, щоб їх можна було переписати, не шукаючи по екрану.
//
// Масиви створюються один раз: хмарка розпізнає «ту саму ситуацію» за
// посиланням на масив і не тасує репліку на кожен рендер.

// Після догляду — своя репліка на кожен препарат. Компост і добриво
// звучать після посадки, полив і оприскування — одразу.
export const AFTER_CARE = {
  fertilizer: ["Ам-ням-ням-ям", "Юху, делікатес!", "Ой як гарно, ой як смачно", "Знатне добривце!", "Фосфор – все, що треба дорослому кущу"],
  compost: ["Дивись, який я уже виріс", "Мої корінці на 7 небі"],
  water: ["Ууу, водичка, гарно, свіжо", "Ооо каєф", "Що треба у жаркий день", "Аква де віда!"],
  insecticide: ["Смерть букашкам!", "Уф, яке полегшення!", "Так-так, шо треба", "Ці вже комахи, сам знаєш"],
};

// Переходу потрібно кілька доглядів, а зроблено ще не всі.
export const MORE = ["Дякую! Ще трохи, будь ласка!"];

// Дали не той препарат. Перший тап — випадкова з трьох: та, що називає,
// чого кущ хоче насправді, «Ти щось не то клацаєш» і «Це не те, що я
// просив...»; повтори — варіанти з його поточного стану (state — той самий
// масив, що хмарка показує без дій: DRESSED, SAD, stageLines…) (власник,
// 27.09.2026). Якщо в стані одна репліка, до неї додаються перші, щоб
// повтори чергувались.
const WANTED = { water: "води", compost: "компосту", fertilizer: "добрива", insecticide: "оприскування", outfit: "одягу" };
const OTHER = ["Ти щось не то клацаєш", "Це не те, що я просив..."];
const firstCache = {};
export const wrongFirst = (need) =>
  (firstCache[need] ??= [WANTED[need] ? `Хочу ${WANTED[need]}, а не оце` : "Мені зараз потрібне інше", ...OTHER]);
const moreCache = new WeakMap();
export const wrongMore = (first, state) => {
  if (state.length > 1) return state;
  let byFirst = moreCache.get(state);
  if (!byFirst) moreCache.set(state, (byFirst = new Map()));
  if (!byFirst.has(first)) byFirst.set(first, [...state, ...first]);
  return byFirst.get(first);
};

// Одна стадія на добу — сказано у відповідь на дію.
export const TOO_SOON = ["Мені треба трохи часу, щоб підрости", "Росту собі... Приходь завтра"];
export const ON_SALE = ["Поки я на ринку, доглядати за мною не потрібно"];
export const GROWN = ["Я вже дорослий – одягни мене"];
export const BARREL = ["Мої боби – мій скарб, але я охоче подарую їх в обмін на комплект одягу"];

// Сервер відмовив із причиною, якої ми не чекали. Сирий текст помилки
// кавенятку не личить (власник: «тут має бути щось quirky»); про обрив
// звʼязку каже тост, тож сюди він не потрапляє.
export const OOPS = [
  "Ой, щось у мене гілочки заплутались. Спробуй ще раз?",
  "Хм, земля трусонулась. Давай ще раз",
  "Щось пішло не за планом. Я не винен, я кущ",
];

// ── стан, коли нічого щойно не сталось ─────────────────────────────────
// Посадку почали й кинули: розставлене вже видно на кущі, тож «я лисенький»
// звучало б дивно. Що саме садили — словом (власник, 02.10.2026).
// Масиви сталі, а не нові на кожен рендер: репліку порівнюють за посиланням,
// і новий масив щоразу перезапускав би друк.
const DRAFTED = {
  leaves: ["Ти вже почав садити листя – давай завершимо!"],
  branches: ["Ти вже почав садити гілки – давай завершимо!"],
  buds: ["Ти вже почав садити бутони – давай завершимо!"],
};
export const drafted = (kind) => DRAFTED[kind] ?? DRAFTED.leaves;

// Сьогодні вже підріс — далі завтра.
export const WAITING = [
  "Росту собі... Приходь завтра",
  "Тепер дай трохи часу пустити корені",
  "Все, що треба для щастя, – крім часу",
  "У мене кущащі справи, заглянь завтра",
  "Я кущ, я кущ, я кущ, і зовсім не ШІ",
  "Я веселе кавеня, ля-ля-ля",
];

// 7+ днів без поливу.
export const WITHERED = [
  "Мене не поливали мінімум тиждень. ТИЖДЕНЬ!",
  "Ну броооо, тобі шо, жалко?",
  "Оце так ти про мене дбаєш",
  "Води. ВОДИ!",
  "Ще трохи – і перетворюся на хмиз.",
  "Повний сушняк.",
  "Кущам – води!",
];

// 3+ дні без поливу.
export const SAD = [
  "Полий мене, будь ласка!",
  "Ти нічого не забув?",
  "Привіт. Ти ж не даси мені всохнути?",
  "Відчуваю, наче мене ігнорують",
  "Дай попити",
  "Щось в корінці пересохло",
];

// Усі препарати по нулях.
export const EMPTY = ["Поличка порожня. Купи хоч води, будь людиною", "Запаси скінчились, почалися злидні"];

// Дорослий і вдягнений.
export const DRESSED = [
  "Я кущ, я кущ, я кущ, і зовсім не ШІ",
  "Я веселе кавеня, ля-ля-ля",
  "Я такий модний, але завжди можна краще",
  "В мене в гардеробі купа місця (ні на що не натякаю)",
  "Час обновок!",
  "Я кущ. Я кущ? Я кууууууущ!",
  "В чому сенс бути кущем без нового комплекту одягу",
  "Та-парапапапапа па па, купи мені ще одяг",
  "Каваааабунга!",
];

// За стадією. На 5 і 6 препарат не заданий, а випадає для кожного куща
// свій (economy.json: «fertilizer|insecticide», сервер обирає в pickNeed),
// тож і репліка — під той, що випав.
const STAGE = [
  ["Мене щойно посадили. Полий мене, будь ласка!"],
  ["Щось я лисенький... Погодуй – пущу листя!"],
  ["Я кущ! Вирости на мені гілочки!"],
  ["Час цвісти... Посади на мені бутон!"],
  ["Перший бутон. Як перший поцілунок."],
  null,
  null,
  ["Дякую тобі, ти мій найкращий друг"],
  ["Я цвіту. Я цвіту? Романтика..."],
  ["Мої боби майже дозріли!"],
  ["Вуху! Я дорослий кущ!"],
];
const FEED = ["Погодуууууй мене"];
const BUGS = ["В мене завелися комахи. О ні!"];
const BY_NEED = { 5: { fertilizer: FEED, insecticide: BUGS }, 6: { fertilizer: FEED, insecticide: BUGS } };

// Запасна — якщо стадії немає в таблиці (не має траплятись).
export const FALLBACK = ["Шалалала, про що я думав?.."];

export const stageLines = (stage, need) => BY_NEED[stage]?.[need] ?? BY_NEED[stage]?.fertilizer ?? STAGE[stage] ?? FALLBACK;
